import { getQueryParams } from '../util';

export const getFilterPath = (answers, slug, params = { size: 4 }) => {
    if (!answers) {
        return '';
    }

    //loops through filters and merges key value pairs into an object
    const updatedFilters = answers.reduce((acc, { filter }) => {
        Object.keys(filter).forEach(key => {
            const value = filter[key];
            if (!acc[key]) {
                acc[key] = {};
            }
            const valueMap = value.reduce((acc, val) => {
                acc[val] = val;
                return acc;
            }, {});
            acc[key] = { ...acc[key], ...valueMap };
        });

        return acc;
    }, {});

    return getQueryParams(slug, updatedFilters, params);
};

export const getRemainingQuestions = (questions, lastAnswer) => {
    if (!lastAnswer) {
        return questions;
    }
    //if the last selected answer has nested questionsAnswers, use those as the the remaining questions
    const nestedQuestions = lastAnswer.questionsAnswers;
    if (nestedQuestions) {
        return nestedQuestions;
    }
    return questions;
};
